<div class="op-modal--portal ">
  <div class="op-modal--modal-container dynamic-content-modal--wrapper loading-indicator--location"
       data-indicator-name="modal"
       tabindex="0">
  </div>
</div>
